import type { ReactElement } from 'react';

/** The mockup's inline SVG icons (salon-mockup.html ICON), unchanged (D-53). */
const line = { fill: 'none', stroke: 'currentColor' } as const;

export const Icon = {
  today: () => (
    <svg className="ic" viewBox="0 0 100 100" {...line}>
      <rect x="15" y="15" width="70" height="70" rx="23" strokeWidth="8" />
      <rect x="31" y="30" width="26" height="9" rx="4.5" fill="currentColor" stroke="none" />
      <rect x="31" y="45" width="38" height="11" rx="5.5" fill="currentColor" stroke="none" />
      <rect x="31" y="62" width="17" height="9" rx="4.5" fill="currentColor" stroke="none" />
    </svg>
  ),
  cal: () => (
    <svg className="ic" viewBox="0 0 24 24" {...line} strokeWidth="1.7">
      <rect x="3" y="5" width="18" height="16" rx="2.5" />
      <path d="M3 10h18M8 3v4M16 3v4M8 14h3M8 17.5h3M14 14h2M14 17.5h2" />
    </svg>
  ),
  msg: () => (
    <svg className="ic" viewBox="0 0 24 24" {...line} strokeWidth="1.7">
      <path d="M21 11.5a8.4 8.4 0 0 1-9 8.4L3 21l1.1-3.6A8.4 8.4 0 1 1 21 11.5Z" />
    </svg>
  ),
  ppl: () => (
    <svg className="ic" viewBox="0 0 24 24" {...line} strokeWidth="1.7">
      <circle cx="9" cy="8" r="3.4" />
      <path d="M2.6 20a6.6 6.6 0 0 1 12.8 0" />
      <path d="M16.5 5.2a3.4 3.4 0 0 1 0 6.6M17.5 14.2A6.6 6.6 0 0 1 21.4 20" />
    </svg>
  ),
  set: () => (
    <svg className="ic" viewBox="0 0 24 24" {...line} strokeWidth="1.7">
      <circle cx="12" cy="12" r="3.2" />
      <path d="M19.4 14.4a1.7 1.7 0 0 0 .34 1.88l.06.06a2 2 0 1 1-2.84 2.84l-.06-.06a1.7 1.7 0 0 0-2.9 1.2V21a2 2 0 1 1-4 0v-.11a1.7 1.7 0 0 0-2.98-1.14l-.06.06a2 2 0 1 1-2.84-2.84l.06-.06A1.7 1.7 0 0 0 3.1 14.4H3a2 2 0 1 1 0-4h.11A1.7 1.7 0 0 0 4.25 7.4l-.06-.06A2 2 0 1 1 7.03 4.5l.06.06a1.7 1.7 0 0 0 1.88.34H9a1.7 1.7 0 0 0 1-1.55V3a2 2 0 1 1 4 0v.11a1.7 1.7 0 0 0 2.9 1.2l.06-.06a2 2 0 1 1 2.84 2.84l-.06.06a1.7 1.7 0 0 0-.34 1.88V9a1.7 1.7 0 0 0 1.55 1H21a2 2 0 1 1 0 4h-.11a1.7 1.7 0 0 0-1.49 1.4Z" />
    </svg>
  ),
  scis: () => (
    <svg className="ic" viewBox="0 0 24 24" {...line} strokeWidth="1.7">
      <circle cx="6" cy="6" r="2.6" />
      <circle cx="6" cy="18" r="2.6" />
      <path d="M8.2 7.6 20 18M8.2 16.4 20 6" />
    </svg>
  ),
  srch: () => (
    <svg viewBox="0 0 24 24" {...line} strokeWidth="1.8" width={16} height={16} style={{ flex: '0 0 auto', color: 'var(--faint)' }}>
      <circle cx="11" cy="11" r="6.5" />
      <path d="M16 16l4.5 4.5" />
    </svg>
  ),
  plus: () => (
    <svg viewBox="0 0 24 24" {...line} strokeWidth="2">
      <path d="M12 5v14M5 12h14" />
    </svg>
  ),
  send: () => (
    <svg viewBox="0 0 24 24" {...line} strokeWidth="1.8">
      <path d="M21 3 10.5 13.5M21 3l-6.8 18-3.7-7.5L3 9.8 21 3Z" />
    </svg>
  ),
  back: () => (
    <svg viewBox="0 0 24 24" {...line} strokeWidth="2">
      <path d="M15 19l-7-7 7-7" />
    </svg>
  ),
  chev: () => (
    <svg viewBox="0 0 24 24" {...line} strokeWidth="1.8">
      <path d="M9 5l7 7-7 7" />
    </svg>
  ),
  L: () => (
    <svg viewBox="0 0 24 24" {...line} strokeWidth="1.8">
      <path d="M15 5l-7 7 7 7" />
    </svg>
  ),
  R: () => (
    <svg viewBox="0 0 24 24" {...line} strokeWidth="1.8">
      <path d="M9 5l7 7-7 7" />
    </svg>
  ),
  tickRow: () => (
    <svg className="ag-ok" viewBox="0 0 24 24" {...line} strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 12.5l5.5 5.5L20 7" />
    </svg>
  ),
  chatpill: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" {...line} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="5" width="18" height="13" rx="5" />
      <path d="M8 11.5 H16" />
    </svg>
  ),
  move: () => (
    <svg width="22" height="22" viewBox="0 0 24 24" {...line} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="4" y="5" width="16" height="15" rx="3" />
      <path d="M4 10 H20" />
      <path d="M10 15 H15 M13 13 L15 15 L13 17" />
    </svg>
  ),
  extend: () => (
    <svg width="22" height="22" viewBox="0 0 24 24" {...line} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="7.5" />
      <path d="M12 8.5 V12 L14.5 13.5" />
      <path d="M19 3.5 V7.5 M17 5.5 H21" />
    </svg>
  ),
  repeat: () => (
    <svg width="22" height="22" viewBox="0 0 24 24" {...line} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 11 A7 7 0 0 1 18 8" />
      <path d="M18 4 V8 H14" />
      <path d="M19 13 A7 7 0 0 1 6 16" />
      <path d="M6 20 V16 H10" />
    </svg>
  ),
  tick: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" {...line} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 12.5 L10 17 L19 7.5" />
    </svg>
  ),
  /* Card 12 contact sheets (D-85; salon-mockup.html C_PHONE, C_SMS, C_CHAT). */
  phone: () => (
    <svg viewBox="0 0 24 24" {...line} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 3.5h3.2l1.6 4.2-2.1 1.4a11 11 0 0 0 5.2 5.2l1.4-2.1 4.2 1.6V17a2.5 2.5 0 0 1-2.7 2.5A15.5 15.5 0 0 1 2.5 6.2 2.5 2.5 0 0 1 5 3.5Z" />
    </svg>
  ),
  sms: () => (
    <svg viewBox="0 0 24 24" {...line} strokeWidth="1.7">
      <path d="M4 5h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H9l-5 4v-4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Z" />
    </svg>
  ),
  chat: () => (
    <svg viewBox="0 0 24 24" {...line} strokeWidth="1.7">
      <path d="M21 11.5a8.4 8.4 0 0 1-9 8.4L3 21l1.1-3.6A8.4 8.4 0 1 1 21 11.5Z" />
    </svg>
  ),
};

/** The MasterDay mark, «Framed list» (D-21). Colour from --ring / --tick. */
export function Mark({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 100 100" aria-hidden="true">
      <rect x="15" y="15" width="70" height="70" rx="23" fill="none" style={{ stroke: 'var(--ring)' }} strokeWidth="9" />
      <rect x="31" y="30" width="26" height="9" rx="4.5" style={{ fill: 'var(--tick)' }} />
      <rect x="31" y="45" width="38" height="11" rx="5.5" style={{ fill: 'var(--tick)' }} />
      <rect x="31" y="62" width="17" height="9" rx="4.5" style={{ fill: 'var(--tick)' }} />
    </svg>
  );
}

/** Messenger logos for the chat header (screen 10, header C2; salon-mockup.html LOGO). SMS has none. */
const LOGO: Record<string, [string, string, ReactElement]> = {
  telegram: ['tg', 'Telegram', (
    <svg viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="10.5" style={{ fill: 'var(--logo-tg)' }} />
      <path style={{ fill: 'var(--logo-ink)' }} d="M5.6 11.6l11-4.3c.5-.2 1 .1.8.9l-1.9 8.9c-.1.6-.5.8-1 .5l-2.9-2.1-1.4 1.4c-.2.2-.3.3-.6.3l.2-3 5.4-4.9c.2-.2 0-.3-.4-.1l-6.6 4.2-2.8-.9c-.6-.2-.6-.6.2-.9z" />
    </svg>
  )],
  whatsapp: ['wa', 'WhatsApp', (
    <svg viewBox="0 0 24 24">
      <path style={{ fill: 'var(--logo-wa)' }} d="M12 1.8a10.2 10.2 0 0 0-8.8 15.4L1.8 22.2l5.1-1.3A10.2 10.2 0 1 0 12 1.8z" />
      <path style={{ fill: 'var(--logo-ink)' }} d="M8.5 6.9c.2-.4.4-.4.7-.4h.6c.2 0 .4 0 .6.5l.8 1.9c.1.2.1.4 0 .6l-.4.6c-.1.2-.2.3 0 .6.4.8 1 1.5 1.7 2.1.6.5 1.3.9 2 1.2.2.1.4 0 .5-.1l.7-.8c.2-.2.4-.2.6-.1l1.8.9c.2.1.4.2.4.4.1.3 0 1.1-.4 1.6-.4.5-1.3.9-2 .9-.8 0-2.5-.4-4.2-1.9-1.8-1.6-2.8-3.4-3.1-4.2-.3-.8-.2-1.9.4-2.7z" />
    </svg>
  )],
  instagram: ['ig', 'Instagram', (
    <svg viewBox="0 0 24 24">
      <rect x="6" y="6" width="12" height="12" rx="3.6" fill="none" style={{ stroke: 'var(--logo-ink)' }} strokeWidth="1.8" />
      <circle cx="12" cy="12" r="2.9" fill="none" style={{ stroke: 'var(--logo-ink)' }} strokeWidth="1.8" />
      <circle cx="16.2" cy="7.8" r="1" style={{ fill: 'var(--logo-ink)' }} />
    </svg>
  )],
};

export function ChannelLogo({ channel }: { channel?: string }) {
  const logo = channel ? LOGO[channel] : undefined;
  if (!logo) return null;
  return (
    <span className={`ch-logo ${logo[0]}`} role="img" aria-label={logo[1]} title={logo[1]}>
      {logo[2]}
    </span>
  );
}
